import React from 'react'
import { Paper, SearchBar, Table } from '../ui/core';
import { isDate } from 'moment';

export default function list({items,onClick}) {
    const headers = [
        { label: 'Titel', attribute: 'title', default: true },
        { label: 'Datum', attribute: 'date', default: true ,isDate:true},
        { label: 'Gepubliceerd', attribute: 'publish', default: true ,isBoolean:true},
    ] 
    //    <SearchBar />
    return (
        <> 
            <div className="padding"><Table items={items} headers={headers} onClick={onClick}/></div>
        </>
    )
}
